import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query'; 
import Layout from '../common/components/Layout';
import EmployeeDetailCard from '../common/components/EmployeeDetailCard';
import EmployeeLeaveAllocationCard from '../common/components/EmployeeLeaveAllocationCard';
import EmployeeLeaveListView from './Settings/Leave Management/Leave Configuration/LeaveListView';

const EmployeeLeaveView = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const queryClient = useQueryClient(); 

  const handleRefreshLeaves = () => {
    if (id && id !== 'undefined') {
      // Invalidate the leave list to refresh the table in EmployeeLeaveListView
      queryClient.invalidateQueries({ queryKey: ['leaveList', id] });
      
      // Invalidate the balances to refresh the table in EmployeeLeaveAllocationCard
      queryClient.invalidateQueries({ queryKey: ['employeeLeaveBalances', id] });
    }
  };

  return (
    <Layout>
      <div className="d-flex justify-content-between align-items-center mb-4 px-2">
        <h2 className="fw-bold text-dark m-0">
          Employee Leave
        </h2>
        
        <div className="d-flex gap-2">
          <button 
            className="btn text-white btn-sm px-3 fw-bold shadow-sm" 
            style={{ height: '35px', backgroundColor: '#0f172a', border: 'none', display: 'flex', alignItems: 'center' }}
            onClick={() => navigate("/leave-management")}
          >
            <i className="bi bi-arrow-left-circle me-2"></i> Back
          </button>
        </div>
      </div>

      <EmployeeDetailCard />
      <EmployeeLeaveAllocationCard id={id} onRefresh={handleRefreshLeaves} />
      <EmployeeLeaveListView id={id} onRefresh={handleRefreshLeaves} />

    </Layout>
  );
};

export default EmployeeLeaveView;